import _createClass from './../../../external_lib/@babel/runtime/helpers/esm/createClass.js';
import _classCallCheck from './../../../external_lib/@babel/runtime/helpers/esm/classCallCheck.js';
var AbstractCalculator = /*#__PURE__*/_createClass(function AbstractCalculator() {
  _classCallCheck(this, AbstractCalculator);
});
export { AbstractCalculator as default };
//# sourceMappingURL=calculator.js.map
